import {View, Text} from 'react-native';
import React from 'react';
import ButtonComponent from '../../../components/ButtonComponent/ButtonComponent';
import {AppRoutes} from '../../../navigation/Routes.types';
import {NavigationProps} from '../../../navigation/Routes';
import {useUserStore} from '../../../store/UserStore';
import {useNavigation} from '@react-navigation/native';
interface INotFound {
  title: string;
  description?: string;
}

const NotOrder = ({title, description}: INotFound) => {
  const {user} = useUserStore();
  const {navigate} = useNavigation<NavigationProps>();

  return (
    <View
      style={{
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 100,
      }}>
      <Text
        style={{
          fontSize: 22,
          fontFamily: 'TCCC-UnityText Bold',
          lineHeight: 26,
          color: 'black',
          marginTop: 20,
          maxWidth: 250,
          textAlign: 'center',
        }}>
        {title}
      </Text>
      <Text
        style={{
          fontSize: 16,
          fontWeight: '400',
          lineHeight: 20,
          color: 'gray',
          maxWidth: 250,
          textAlign: 'center',
          marginTop: 10,
        }}>
        {description}
      </Text>
      {!!user?.storeAccess && (<ButtonComponent
        width="100%"
        title=" Aproveite e realize um pedido "
        onPress={() => (navigate as any)(AppRoutes.MAIN_TAB_SCREEN, { screen: 'Home' })}
      />)}
    </View>
  );
};

export default NotOrder;
